import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class FacilityManager extends EntityDto implements IEntityDto {
    FacilityManager_Id: string;
    FacilityManagerName: string;
    FacilityManagerAddress: string;
    Emp_Ref_Id:string;
    EmployeeName:string;
    
    Phone: string;
    EmailId: string;
    TotalCount: number;
    IsActive: boolean;
    // Department_Id: string;
    // DepartmentName: string;
   
    constructor() {
        super();
        this.FacilityManager_Id = "00000000-0000-0000-0000-000000000000";
        this.FacilityManagerName = "";
        this.FacilityManagerAddress = "";
        this.EmailId = "";
        this.TotalCount = 0;
        this.Phone = "";
        this.IsActive = true;
        this.Emp_Ref_Id="00000000-0000-0000-0000-000000000000";
        // this.Department_Id="";
        // this.DepartmentName="";
        this.EmployeeName=""
        
        this.EntityMetaData = [
             { FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Facility Manager Name is required' },
            // { FieldName: 'FacilityManagerAddress', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Address is required' },
            // { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
            { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email is required' },
        ];
    }
}
